import { render, staticRenderFns } from "./IndicatorTablePage.vue?vue&type=template&id=6813f30c&scoped=true&"
import script from "./IndicatorTablePage.vue?vue&type=script&lang=js&"
export * from "./IndicatorTablePage.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorTablePage.vue?vue&type=style&index=0&id=6813f30c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813f30c",
  null
  
)

export default component.exports